import { Status } from "@sentry/browser";

export const LOGIN_MESSAGES = {
    OTP_SENT_SUCCESS: 'OTP has been sent to the registered mobile number.',
    OTP_SENT_ERROR: 'OTP has been sent to the registered mobile number.', // BE Error "Email Does not exist",
    OTP_FORM_INVALID: 'Please correct the validation errors to proceed',
    LOGIN_ERROR: 'Failed to login with the provided credentials.',
    // BE: non_field_errors: Unable to log in with provided credentials.
    FORGOT_PASSWORD_INVALID: 'Please Enter the email in the correct format to get a Forgot Password link.',
    RESET_PASSWORD_SUCCESS: 'You will be redirected to the login page shortly.',
    SERVICE_FORBIDDEN: `Looks like you do not have access to the CP Online portal. 
    Please contact the Administrator.`
};

export const INVESTOR_MESSAGES = {
    INVESTOR_OFFER_ACCEPTED: 'Offer Accepted',
    APPROVES_DOCS: 'Docs Approved',
    INVESTOR_WITHDRAWS: 'Offer Withdrawn',
    REJECT_DOCUMENT_SUCCESS: 'Successfully rejected the document',
    INVESTOR_SUBMITS_BID: 'Quote Submitted',
    // !ToDo Add API error messages based on response
    INVESTOR_SUBMIT_BID_FAILED: 'Failed to submit Quote',
    IGNORE_AUCTION_SUCCESS: 'Successfully ignored the RFQ.',
    IGNORE_AUCTION_PROMPT: 'Are you sure you want to ignore the RFQ?',
    IGNORE_AUCTION_CONFIRMATION: `You will not be able to participate in an RFQ once ignored.`,
    ACCEPT_BID_SUCCESS: 'Successfully accepted the Quote.',
    REJECT_BID_SUCCESS: 'Successfully rejected the Quote.',
    COUNTER_BID_SUCCESS: 'Successfully countered the Quote.'
};

export const IPA_MESSAGES = {
    IPA_CERT_ADD_DATA: 'IPA Certificate details updated',
    SIGNATORIES_ADDED: 'Signatories added successfully',
    CHECKLIST_SUCCESS: 'successfully saved the checklist.',
    CHECKLIST_FAILED: 'Failed to save the checklist.',
    IPA_SENDS_DOCS: 'Documents Sent',
    REJECT_DOCUMENTS_SUCCESS: 'Successfully rejected the documents',
    FTRAC_REPORT_NOT_FOUND: 'Failed to download the F-Trac Report.'
};

export const ISSUER_MESSAGES = {
    ISIN_ERROR: `ISIN must be 12 characters long, start with \'IN\' and have \'14\' at the 8 and 9 
    character position.`,
    INVALID_FORM: 'Please correct the validation errors.',
    CREDIT_RATING_SAVE: 'Successfully saved the credit rating details.',
    ON_BR_UPDATE: 'Board Resolution uploaded',
    ON_SIGNATORY_UPDATE: 'Signatories updated.',
    VALUE_DATE_HOLIDAY: 'Value Date must not be a weekend or a Mumbai Business Holiday',
    VALUE_DATE_FUTURE: 'Value Date must be today or a future date.',
    AUCTION_EXPIRY_HOLIDAY: 'RFQ Expiry Date must not be a weekend or a Mumbai Business Holiday',
    CP_CREATE_SUCCESS: 'CP Created Successfully',
    ON_BACKSTOP_SAVE: 'Back Stop details added',
    ISSUE_EXPIRY: 'Please correct the issue expiry error.',
    ISSUE_CREATE_SUCCESS: 'Issue Created Successfully',
    ISSUE_EDIT_SUCCESS: 'Issue Modified Successfully',
    ISSUE_DELETE_SUCCESS: 'Issue Deleted Successfully',
    OFF_PLATFORM_BID_FAILED: 'There was an error while creating issue.',
    DCN_ADDITIONAL_DATA: 'Deal Confirmation Note details updated',
    ISSUER_TO_IPA_ADDITIONAL_DATA: 'Issuer Confirmation to IPA details updated',
    DOC_DATE_ADDITIONAL_DATA: `Updated the Date for `,
    MCF_SENT_TO_NSDL: 'Email sent to NSDL', // Removed
    SIGNED_DOCS_SENT: 'Documents Sent.',
    MCF_ADDN_DATA: 'Master Creation Form additional details updated',
    PROOF_OF_STAMP_DUTY_UPDATED: 'Proof of Stamp Duty Payment uploaded.',
    NO_PROOF_OF_STAMP_DUTY_SUBMIT: 'Please upload proof of stamp duty payment.',
    NO_CP_VALUE: 'Please correct the validation errors to update CP value.',
    PROMISSORY_ADDN_DATA_SUCCESS: 'Promissory note details updated.',
    ADDN_ATTACHMENT_DONE: 'Additional attachment Uploaded',
    ADDN_DATA_SAVED: 'additional details added',
    ISIN_ERROR_SHORT: 'Please enter the ISIN number in the correct format.',
    ISIN_ERROR_SHORT_NEW: 'Commercial Paper with the entered ISIN has already been onboarded.',
    ISIN_SAVED: 'ISIN Saved.',
    INCORRECT_CP_ID: 'The requested Commercial Paper was not found.',
    ISSUE_CLOSED: 'Issue Closed',
    ACCEPT_OFFER_SUCCESS: 'Successfully accepted the offer.',
    REJECT_OFFER_SUCCESS: 'Successfully rejected the offer.',
    COUNTER_OFFER_SUCCESS: 'Successfully countered the offer.',
    // !ToDo Add API error messages based on response
    ISSUER_SUBMIT_BID_FAILED: 'Failed to submit Offer',
    ASYNC_PROMISSORY_NOTE_UPLOAD: 'Please upload signed Promissory Note',
    PER_DOC_SIGNATORY_ADDED: 'Signatories added successfully',
    PROM_NOTE_UPLOADED: 'Successfully uploaded signed Promissory Note',
    SAVE_SIGNATORY_WO_SIGNATORY_FILE: `Please upload a new Signatory List Document for updating the
     signatory data.`,
    CP_VALUE_UPDATED_SUCCESSFULLY: 'Successfully updated the CP value',
    CAF_ISSUANCE_ADDITIONAL_DATA: 'Additional data for Issuance has been updated successfully.',
    REJECT_DOCUMENTS_SUCCESS: 'Successfully rejected the documents',
    AUCTION_CREATION_SUCCESS: 'Request For Quote (RFQ) Created Successfully',
    LAUNCH_AUCTION_PROMPT: 'Click Cancel to Go Back and Confirm to create new RFQ.',
    LAUNCH_AUCTION_CONFIRMATION: `Clicking on Confirm will start an RFQ and notify selected
    investors.`,
    FAILED_TO_GET_ISSUE: `Failed to fetch the issue details.
    Try again or contact the administrator if the problem persists.`
};

export const COMMON_MESSAGES = {
    SESSION_EXPIRY: 'Your current session has expired. Please login again.',
    NO_INTERNET: `Encountered an issue while processing your request. 
    Please check your internet connection and retry.`,
    RESOURCE_NOT_FOUND: 'The requested resource was not found.',
    FILE_SIZE_EXCEEDED: 'Uploaded File Size exceeds the Maximum Allowed Size (25MB).', // !ToDo
    INTERNET_SERVER_ERROR: `Encountered an issue while processing your request,
    the concerned team has been notified, please try again after some time.`,
    LETTERHEAD_UPLOAD_FAILED: 'Failed to upload the letterhead.',
    LETTERHEAD_UPLOAD_SUCCESS: 'Successfully uploaded the letterhead.',
    LETTERHEAD_UPLOADED_INVALID: 'Please select an image to upload.',
    LETTERHEAD_ADJUSTMENT_BOX_ERROR: 'Please adjust the box dimensions properly and try again.',
    SIGNED_DOCS_UPLOADED: 'Sucessfully uploaded the Signed Documents.',
    PARTIAL_DOCS_INVALID: 'Please upload all the signed documents.',
    FILE_FORMATS_WARNING: 'All uploaded files should be of the following types/extensions:',
    REJECT_REASON_MISSING: 'Please enter the reason for the rejection',
    REJECTED_DOCUMENTS_MISSING: 'Please select the documents to reject',
    DOCS_SIGNING_UPLOAD_OR_ESIGN: 'Successfully uploaded signed document(s) or sent document(s) for signing',
    DOCS_SENT_FOR_SIGNING_ONLY: 'Successfully sent document(s) for signing',
    DOCS_UPLOADED_SIGNED_ONLY: 'Successfully uploaded signed document(s)',
    FILE_UPLOADED_SUCCESSFULLY: ' Uploaded Successfully.',
    LISTING_OPENING_CLOSING_DATE_REQUIRED: 'Both Opening and Closing dates are required for all issues.',
    LISTING_ISSUE_DATA_SAVED: 'Successfully saved the Listing opening dates for the issues.',
    SCRIP_CODE_REQUIRED: 'Scrip Code is required to generate the document.',
    SCRIP_CODE_SAVED: 'Successfully saved the Scrip Code.',
    RESEND_EMAIL_SUCCESS: 'Successfully sent the reminder email.',
    DOCUMENT_KEY_NOT_FOUND: 'The link has expired. Please contact Administrator to enable a new link.',
    UPLOAD_DOCS_CONFIRMATION: `Confirming below will upload Signed Docs. Do you wish to continue ?`,
    SIGNATORY_CONFIRMATION: `Confirming will send the generated Docs to selected Signatories.
    Do you wish to continue ?`,
    SIGNATORY_UPLOAD_DOCS_CONFIRMATION: `Confirming will upload Signed docs and send docs
     to selected Signatories. Do you wish to continue ?`,
    SEND_REMINDER_TO_SIGNATORY: `Confirming will send a Reminder Email to the signatories mentioned above.
    Do you wish to Confirm ?`,
    REMIND_CONFIRM_TITLE: 'Remind Signatories ?'
};

export const ADMIN_MESSAGES = {
    INVALID_FORM: 'Please correct the validation errors.',
    ACCEPT_TNC: 'Please agree to the term and conditions.',
    CORPORATE_DETAILS_SUCCESS: `Corporate details successfully submitted. 
    Please add users to finish the sign up process.`,
    CREATE_USERS_ERROR_CORP_DATA: 'Please fill up the corporate details before adding users.',
    ON_USER_CREATE_SUCCESS: `User details submitted successfully. 
    Please wait for our administrator to get back to you. Thank You.`,
    COMPANY_ADMIN_ADDED: 'Successfully updated Admin Users.',
    COMPANY_DIVISION_ADDED: 'Successfully Added the new Division(s).',
    COMPANY_DIVISION_UPDATED: 'Successfully Updated the Division Data.',
    COMPANY_BASIC_INFO: 'Updated corporate basic information.',
    EXECUTIVE_DETAILS_SUCCESS: 'Saved the Executive Details.',
    ACCOUNT_DETAILS_SAVED: 'Account Details saved successfully.',
    BANK_BORROWINGS_SAVED: 'Successfully Saved Bank Borrowing',
    CREDIT_RATINGS_SAVED: 'Credit Ratings details saved successfully.',
    BOARD_RES_SAVED: 'Board Resolution details saved successfully.',
    CONNECTIVITY_DETAILS_SAVED: 'Connectivity Details saved successfully.',
    CREDIT_RATING_DELETED: 'Successfully Deleted Rating',
    OLD_CPS_DELETED: 'Old CP Deleted.',
    OLD_CP_DATA_SAVED: 'Successfully saved the old cp data.',
    OLD_CP_DATA_FAILED: 'Failed to save the old cp data.',
    CP_CREDIT_RATINGS_UPDATED: 'Updated the credit ratings for the CP',
    FINANCIAL_STATEMENT_NOT_FOUND: `Please save the Company Financials before adding the Financial Year 
    Records.`,
    FINANCIAL_STATEMENT_UPLOADED: 'Financial Summary Document Successfully uploaded',
    FINANCIAL_STATEMENT_SAVED: 'Successfully saved the financial year data.',
    FINANCIAL_COMMON_SAVED: 'Successfully saved the company financial details.',
    FINANCIAL_SUMMARY_DELETED: 'Financial Summary Deleted.',
    IPA_DETAILS_SAVED: 'IPA Details saved successfully.',
    LITIGATION_DETAILS_SAVED: 'Litigation Details Saved Successfully.',
    MCF_DETAILS_SAVED: 'MCF Details saved successfully.',
    DEBT_INSTRS_SAVED: 'Successfully Saved Debt Instrument',
    DEBT_INSTRS_DELETED: 'Deleted debt instrument details.',
    BANK_BORROWING_DELETED: 'Bank Borrowing Deleted.',
    OLD_CP_DELETED: 'Old CP Deleted.',
    OLD_CP_SAVED: 'Successfully saved the old cp data.',
    OLD_CP_CR_SAVED: 'Updated the credit ratings for the Past CP.',
    OLD_CP_CR_LINKED: 'Successfully linked the Credit Rating to the CP.',
    BR_REQUIRED_CREDIT_RATINGS: `Please save the Board Resolution and Signatory before updating 
    the credit ratings.`,
    ROLE_ADD_SUCCESSFUL: 'Successfully added the new role for the division.',
    ROLE_DELETE_SUCCESSFUL: 'Successfully deleted the role for the division.',
    DIVISION_DELETED: 'Successfully deleted the division - ',
    ADMIN_USER_DELETED: 'Successfully Deleted the Admin User.',
    PORTAL_USER_DELETED: 'Successfully Deleted the Portal User.',
    SIGNATORY_DETAILS_SAVED: 'Successfully saved the signatory designations',
    LISTING_SAVE_SUCCESSFUL: 'Successfully saved the Market Listing Details',
    FTRAC_SAVE_SUCCESSFUL:  'Successfully saved the F-Trac Details',
    DIVISION_DEPOSITORY_SAVE_SUCCESS: 'Successfully saved the depository details.',
    DIVISION_DEPOSITORY_EDIT_SUCCESS: 'Successfully updated the depository details.',
    STATE_ROLE_SAVED: 'Successfully assigned the role',
    STATE_ROLE_DELETED: 'Successfully unassigned the role',
    ISSUER_DETAILS_SAVED: 'Issuer Details saved successfully.',
    PROMOTERS_DETAILS_DELETED :'Shareholding details of Promoters deleted successfully',
    PROMOTERS_DETAILS_SAVED :'Shareholding details of Promoters saved successfully',
    PROMOTERS_DETAILS_NOT_FOUND :'Shareholding details of Promoters not found',
    PLEDGED_DETAILS_DELETED :'Details Shares pledged deleted successfully',
    PLEDGED_DETAILS_SAVED  :'Details Shares pledged saved successfully',
    PLEDGED_DETAILS_NOT_FOUND  :'Details Shares pledged not found',
    STATUTORY_AUDITOR_SAVED : 'Details of statutory auditor saved successfully',
    STATUTORY_AUDITOR_NOT_FOUND : 'Details of statutory auditor not found',
    STATUTORY_AUDITOR_DELETED : 'Details of statutory auditor deleted successfully',
    DETAILS_CHANGES_SAVED :'Details of changes saved successfully',
    DETAILS_CHANGES_NOT_FOUND :'Details of changes not found',
    DETAILS_CHANGES_DELETED :'Details of changes deleted successfully',

};

// !ToDo
export const AUCTION_MESSAGES = {
    AUCTION_CLOSED: 'RFQ Closed successfully.'
};
